import { render, staticRenderFns } from "./teamFit.vue?vue&type=template&id=7396a973&"
import script from "./teamFit.vue?vue&type=script&lang=js&"
export * from "./teamFit.vue?vue&type=script&lang=js&"
import style0 from "./teamFit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports